import { render, staticRenderFns } from "./ConsultAdd.vue?vue&type=template&id=5dbe5d17"
import script from "./ConsultAdd.vue?vue&type=script&lang=js"
export * from "./ConsultAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports